module.exports = __webpack_public_path__ + "jingTai/img/three2.440481c1.png";